import React from "react";
import style from "./index.module.scss";

interface DataType {
    firstRest: string;
    firstText: string;
    centerText: string;
    lastText: string;
    lastRest: string;
}

interface MarkFilterContentProps {
    data?: DataType;
    content: string;
}

export default function MarkFilterContent({
    data,
    content
}: MarkFilterContentProps) {
    return (
        <>
            {data?.firstRest}
            {data?.firstText}
            <span className={style.key} style={{ color: "#1890ff" }}>
                {data?.centerText}
            </span>
            {data?.lastText}
            {data?.lastRest}
            {!data && content}
        </>
    );
}
